import React from 'react';
import { InfoIcon } from '@avila-tek/ui/src';

interface AlertProps {
  title: string;
  text: string;
  className?: string;
  show: boolean;
  titleClassName?: string;
  textClassName?: string;
}

function Alert({
  title,
  text,
  show = false,
  className = '',
  titleClassName = '',
  textClassName = '',
}: AlertProps) {
  return (
    <div>
      {show ? (
        <div
          className={`bg-purple-50 rounded-b text-teal-900 px-4 py-3 shadow-md ${className}`}
          role="alert"
        >
          <div className="flex">
            <div className="py-1">
              <InfoIcon className="w-4 h-4 text-purple-300 mr-2" />
            </div>
            <div>
              <p className={`font-bold text-purple-300 ${titleClassName}`}>
                {title}
              </p>
              <p className={`text-sm text-text-gray ${textClassName}`}>
                {text}
              </p>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}

export default Alert;
